import React, { useState } from 'react';
import { Check } from 'lucide-react';

interface ExampleAnswersProps {
  examples: string[];
  hint?: string;
  onSelect: (example: string) => void;
  selectedValue?: string | number;
  fieldType: 'text' | 'number' | 'date' | 'select' | 'radio' | 'checkbox';
}

export function ExampleAnswers({ examples, hint, onSelect, selectedValue, fieldType }: ExampleAnswersProps) {
  const [showAll, setShowAll] = useState(false);

  if (!examples || examples.length === 0) {
    return null;
  }

  const displayExamples = showAll ? examples : examples.slice(0, 3);
  const hasMore = examples.length > 3;

  const isSelected = (example: string) => {
    return String(selectedValue) === example;
  };

  return (
    <div className="mt-2 space-y-2">
      {hint && (
        <p className="text-xs text-gray-500 italic">{hint}</p>
      )}
      <div className="flex flex-wrap gap-2">
        {displayExamples.map((example, index) => (
          <button
            key={index}
            type="button"
            onClick={() => onSelect(example)}
            className={`
              inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm
              transition-all duration-200 ease-in-out
              ${isSelected(example)
                ? 'bg-gray-900 text-white shadow-sm'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900'
              }
            `}
          >
            {isSelected(example) && (
              <Check className="w-3 h-3" />
            )}
            <span className="max-w-[200px] truncate">{example}</span>
          </button>
        ))}
        {hasMore && (
          <button
            type="button"
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center px-3 py-1.5 rounded-full text-sm
              bg-white border border-gray-300 text-gray-600 hover:bg-gray-50
              transition-colors duration-200"
          >
            {showAll ? 'Show less' : `Show ${examples.length - 3} more`}
          </button>
        )}
      </div>
    </div>
  );
}
